// extracted by mini-css-extract-plugin
export default {"loader":"SmallLoader_loader__j2H2X","rotation":"SmallLoader_rotation__Ieqfn"};